// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset } from "@insite/mobius/GridContainer";
import { productLinesStyles } from "@steiner/Overrides/Widgets/BrandDetails/BrandDetailsProductLines";
import { ellipsis } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productLinesStyles.title = {
    variant: "h2",
};

productLinesStyles.productLineContainer = {
    gap: 32,
};

productLinesStyles.innerProductLineContainer = {
    gap: 16,
    css: css`
        ${GridOffset} {
            justify-content: center;
        }
    `,
};

productLinesStyles.productLineNameItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};

productLinesStyles.productLineName = {
    size: "14px",
    css: css`
        text-align: center;
        ${ellipsis(3)};
    `,
};

productLinesStyles.viewAllButtonItem = {
    width: 12,
    css: css`
        width: 100%;
        justify-content: center;
    `,
};

productLinesStyles.productLineImageItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};

productLinesStyles.productLineImage = {
    css: css`
        display: flex;
        aspect-ratio: 1;

        img {
            aspect-ratio: 1;
        }
    `,
};

productLinesStyles.productLineItemRow = {
    width: [12, 6, 4, 3, 2],
};
